import { render } from "./ReceiptsView.vue?vue&type=template&id=29577fe6&ts=true"
import script from "./ReceiptsView.vue?vue&type=script&lang=ts"
export * from "./ReceiptsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__